import { render } from "./MusicPlayerView.vue?vue&type=template&id=1989adce&scoped=true&ts=true"
import script from "./MusicPlayerView.vue?vue&type=script&lang=ts"
export * from "./MusicPlayerView.vue?vue&type=script&lang=ts"

import "./MusicPlayerView.vue?vue&type=style&index=0&id=1989adce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1989adce"]])

export default __exports__